/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.30.0
 */

export enum EWizardCollationReportSteps {
    ChooseStep = 'ChooseStep',
    ConfirmStep = 'ConfirmStep',
}

/*
 * -------------------------------------------
 *           ACTIONS
 * -------------------------------------------
 */

export const WIZARD_COLLATION_REPORT_VALIDATE_START =
    '@@b2b_portal_ui/wizardCollationReport/WIZARD_COLLATION_REPORT_VALIDATE_START';

export const WIZARD_COLLATION_REPORT_VALIDATE_FINISH =
    '@@b2b_portal_ui/wizardCollationReport/WIZARD_COLLATION_REPORT_VALIDATE_FINISH';

export const WIZARD_COLLATION_REPORT_SET_PARAMS =
    '@@b2b_portal_ui/wizardCollationReport/WIZARD_COLLATION_REPORT_SET_PARAMS';

export const WIZARD_COLLATION_REPORT_HANDLE_NEXT =
    '@@b2b_portal_ui/wizardCollationReport/WIZARD_COLLATION_REPORT_HANDLE_NEXT';
